import exportToExcel from "../../../../helpers/exportExcel";
import totalByColumn from "./totalByColumn";
import { t } from "i18next";

export const handleExcelPreprinted = (items, formatCurrency) => {
  const date = new Date();
  const isoDate = date.toISOString();
  let excelData = [];
  const itemExcel1 = {};
  excelData.push(itemExcel1);
  items.map((item) => {
    const itemExcel = {};
    itemExcel[t("agency")] = `(${item.agencyNumber}) ${item.agencyName}`;
    itemExcel[t("delivery")] = formatCurrency(item.deliveryCount) || "-";
    itemExcel[t("return")] = formatCurrency(item.returnCount) || "-";
    itemExcel[t("sales")] = item.salesCount || "-";
    itemExcel[t("collection")] = formatCurrency(item.salesAmount) || "-";
    itemExcel[t("expired")] = formatCurrency(item.expiredAmount) || "-";
    excelData.push(itemExcel);
  });
  const total = {};
  total[t("agency")] = t("totals");
  total[t("delivery")] =
    formatCurrency(items.reduce((acc, item) => acc + item.deliveryCount, 0)) ||
    "-";
  total[t("return")] =
    formatCurrency(items.reduce((acc, item) => acc + item.returnCount, 0)) ||
    "-";
  total[t("sales")] =
    items.reduce((acc, item) => acc + item.salesCount, 0) || "-";
  total[t("collection")] =
    formatCurrency(items.reduce((acc, item) => acc + item.salesAmount, 0)) ||
    "-";
  total[t("expired")] =
    formatCurrency(items.reduce((acc, item) => acc + item.expiredAmount, 0)) ||
    "-";
  excelData.push(total);

  exportToExcel(
    excelData,
    `${t("controlMatrixDeliveryReturn")} ${t("preprinted")} - ${isoDate}`,
  );
};

export const handleExcelInstant = (items, formatCurrency, series) => {
  const date = new Date();
  const isoDate = date.toISOString();

  let arrayObjetos = [];
  const itemExcel1 = {};
  arrayObjetos.push(itemExcel1);

  items.map((item) => {
    let objeto = new Map();
    objeto[t("agency")] = `(${item.agencyNumber}) ${item.agencyName}`;
    for (let i = 0; i < series.length; i++) {
      objeto[series[i]] =
        formatCurrency(item.series.find((s) => s.name === series[i])?.amount) ||
        "-";
    }
    arrayObjetos.push(objeto);
  });

  let totals = totalByColumn(items, series);
  const total = {};
  total[t("agency")] = t("totals");
  series.map((item, i) => {
    total[item] = formatCurrency(totals[i]);
  });
  arrayObjetos.push(total);

  exportToExcel(
    arrayObjetos,
    `${t("controlMatrixDeliveryReturn")} ${t("instant")} - ${isoDate}`,
    [t("agency"), ...series],
  );
};
